
export enum IQuestItemType {
    Check = 'CHECK',
    Daily = 'DAILY',
    Input = 'INPUT'
}
export enum IQuestGiftType {
    Score = 'SCORE',
    Energy = 'ENERGY'
}
export interface IQuestItem {
    questType: IQuestItemType,
    imageUrl: string,
    conditionText: string,
    giftType: IQuestGiftType,
    giftText: string,
    gift: number,
    completed: boolean
}
export type Quest = Record<string, IQuestItem>


export interface IQuestCheck {
    questNameEnum: string,
    secret: string
}
